/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Nav_TitleInputs */

const cs_documents_nav_title = /** @type {(inputs: Documents_Nav_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procházet`)
};

const en_documents_nav_title = /** @type {(inputs: Documents_Nav_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse`)
};

/**
* | output |
* | --- |
* | "Browse" |
*
* @param {Documents_Nav_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_nav_title = /** @type {((inputs?: Documents_Nav_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Nav_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_nav_title(inputs)
	return cs_documents_nav_title(inputs)
});